// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"a9c9963b","453":"4c83a1e4","521":"2f3b7976","885":"d9d8d3e7"}[chunkId] + ".chunk.js";
};